// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/components/modal/specifications.less
// module id = 3184
// module chunks = 0